import './login.scss';

export function LoginController(
    $scope,
    $location
){
    'ngInject';

    $scope.logo = "VMS_Logo.png";
    // Current Year
    $scope.currentYear = new Date().getFullYear();    
    $scope.user = { username: $('#UserName').val(), password: $('#Password').val(), id: $('#BusinessID').val() };
    // Data form
    $scope.master = {};

    $scope.update = function (user) {
        $scope.master = angular.copy(user);
        console.log($scope.master);
    };

    // Single sign in
    $scope.singleSignIn = $location.url();

    if ($scope.singleSignIn == "/#singlelogin") {
        $scope.singleSignInBtn = true;
    } else {
        $scope.singleSignInBtn = false;
    }
    // DONE
}


// WEBPACK FOOTER //
// ./Angular_Code/app/Login/login.controller.js